import { render, staticRenderFns } from "./PackagingDetails_new.vue?vue&type=template&id=56a2a890&scoped=true&"
import script from "./PackagingDetails_new.vue?vue&type=script&lang=js&"
export * from "./PackagingDetails_new.vue?vue&type=script&lang=js&"
import style0 from "./PackagingDetails_new.vue?vue&type=style&index=0&id=56a2a890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2a890",
  null
  
)

export default component.exports